import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InfoTooltipComponent } from '../components/info-tooltip/info-tooltip.component';
import { TooltipDirective } from '../directives/tooltip.directive';
import { MetricCardComponent } from '../metrics/components/metric-card/metric-card.component';
import { PaginatorModule } from './paginator/paginator.module'; // NUEVO 2026-05-19

/**
 * Módulo compartido. Declara y exporta componentes y directivas que pueden
 * reutilizarse en el módulo raíz y en módulos lazy.
 *
 * Política: solo se mueven aquí componentes una vez que un segundo módulo
 * empieza a necesitarlos. Componentes específicos de un dominio (charts del
 * dashboard de evals, tablas de tenants, etc.) permanecen en su módulo origen.
 *
 * Sub-módulos reexportados:
 *  - PaginatorModule: <app-paginator> reutilizable para listados paginados.
 */
@NgModule({
  declarations: [
    InfoTooltipComponent,
    TooltipDirective,
    MetricCardComponent
  ],
  imports: [
    CommonModule,
    PaginatorModule
  ],
  exports: [
    CommonModule,
    InfoTooltipComponent,
    TooltipDirective,
    MetricCardComponent,
    PaginatorModule
  ]
})
export class SharedModule {}